export default {
  surtitle: {
    id: 'pricing_banner_surtitle',
    defaultMessage: 'One rule to rule them all',
  },
  title: {
    id: 'pricing_banner_title',
    defaultMessage: 'International Pricing Tool',
  },
  description: {
    id: 'pricing_banner_description',
    defaultMessage:
      'Set customized pricing rules by market and category. No more copying and pasting your price to each market individually! Update the price in your reference market and in two clicks your price will update across all other markets.',
  },
}
